import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import TextColorPaneConnect from "./TextColorPane";
import $ from "jquery";
import FontFaceObserver from "fontfaceobserver";

const TextStyle = props => {
    return (
        <>
            <div id="text-style" className="row">
                <div
                    id="text-style-1"
                    className="col-md-6 col-sm-12 text-style_1"
                    onClick={() => props.setTextArcStyle("text-style-1")}
                >
                    <img
                        src={require("./../assets/img/text-style_1.png")}
                        alt="style_1"
                        onClick={() => props.setTextArcStyle("text-style-1")}
                    />
                </div>
                <div
                    id="text-style-2"
                    className="col-md-6 col-sm-12 text-style_2"
                    onClick={() => props.setTextArcStyle("text-style-2")}
                >
                    <img
                        src={require("./../assets/img/text-style_2.png")}
                        alt="style_2"
                        onClick={() => props.setTextArcStyle("text-style-2")}
                    />
                </div>
            </div>
        </>
    );
};

class TextTool extends React.Component{

    state={
        update:false,
        text:'Your Text',
        arc:{value:1,},
        outline:{value:1,},
        letterSpace:{value:1,},
        lineHeight:{value:1,},
        text_align:'left',
        fill: '#000000',
        stroke: '#000000',
    }
    componentDidMount() {
        console.log('is mounted');
        $('#text').show()
        $(`#menu li.nav.active`).removeClass('active')
        $(`#menu li.nav.text`).addClass('active');
        if(this.checkBrowser()){
            $('.second-menu').hide()
            document.getElementById("mySidenav11") &&(document.getElementById("mySidenav11").style.width = "300px");
        }
    }

    checkBrowser=()=>{
        let check = false;
        (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
        return check;
    };

    updateText=(e)=>{
        let { value } = e.target;
        this.props.setTextPanelText(value);
        this.setState({text:value});
    }

    addNewText = () => {
        let new_text = this.props.text_toolbar_config.text;
        if (new_text === "") {
            alert("Please input the text");
            return;
        }
        //let text = this.props.canvas._objects[0];
        let activeObject = this.props.canvas.getActiveObject();
        if(activeObject && activeObject.type === 'curvedText'){
            if(this.checkBrowser()){
                let selected = $('.selected_text_edit')[1];
                new_text = selected ? selected.value: new_text;
            }
            activeObject.setText(new_text)
            this.props.canvas.renderAll();
            return;
        }
        let canvas = this.props.canvas,
            centerXCanvas = (canvas.width*canvas.getZoom())/2,
            top = 20;
        let data = {
            fill:'#00FFFF',
            stroke:'#00FFFF',
            text_align:'center',
            fontFamily:'Times New Roman',
            fontSize:20,
            top: top,
            left: 20,
            //fontWeight: text.get("fontWeight"),
            //fontStyle: text.get("fontStyle"),
            lineHeight: 1,
            strokeWidth: 0,
            letterSpace: 1,
            radius:480,
            effect: "STRAIGHT",
        };
        let curvedtext = new window.fabric.CurvedText(new_text,{...data});
        curvedtext.top = (canvas.height/2)-(curvedtext.get('height')/2);
        curvedtext.left = (canvas.width/2)-(curvedtext.get('width')/2);
        canvas.add(curvedtext);
        canvas.renderAll();
        this.updateCanvasState();
    };

    updateCanvasState = () => {
        let tempConfig = this.props._config;
        if (tempConfig.undoStatus === false && tempConfig.redoStatus === false) {
            let jsonData = this.props.canvas.toJSON();
            let canvasAsJson = JSON.stringify(jsonData);
            if (tempConfig.currentStateIndex < tempConfig.canvasState.length - 1) {
                let indexToBeInserted = tempConfig.currentStateIndex + 1;
                tempConfig.canvasState[indexToBeInserted] = canvasAsJson;

                let numberOfElementsToRetain = indexToBeInserted + 1;
                tempConfig.canvasState = tempConfig.canvasState.splice(
                    0,
                    numberOfElementsToRetain
                );
            } else {
                tempConfig.canvasState.push(canvasAsJson);
            }

            tempConfig.currentStateIndex = tempConfig.canvasState.length - 1;

            if (
                tempConfig.currentStateIndex === tempConfig.canvasState.length - 1 &&
                tempConfig.currentStateIndex !== -1
            ) {
                tempConfig.redoButton = "disabled";
            }
        }
        this.props.setTextConfigPanel(true , {});
        this.props.setCanvasConfig(tempConfig);
    };

    setTextStyle = id => {
        let activeObject = this.props.canvas._activeObject;
        if (activeObject == null) return;

        let targetClsName = $("#" + id).attr("class");
        const textStyleOption = id;
        if (targetClsName.indexOf("active") > -1) {
            switch (textStyleOption) {
                case "bold":
                    activeObject.set("fontWeight", "normal");
                    break;
                case "italic":
                    activeObject.set("fontStyle", "");
                    break;
                case "underline":
                    activeObject.set("textDecoration", "");
                    break;
                case "capital":
                    activeObject.text = activeObject.text.toLowerCase();
                    break;
                case "left-align":
                case "center-align":
                case "right-align":
                    activeObject.set("textAlign", "left");
                    break;
                default:
                    break;
            }
        } else {
            switch (textStyleOption) {
                case "bold":
                    activeObject.set("fontWeight", "bold");
                    break;
                case "italic":
                    activeObject.set("fontStyle", "italic");
                    break;
                case "underline":
                    activeObject.set("textDecoration", "underline");
                    break;
                case "capital":
                    activeObject.text = activeObject.text.toUpperCase();
                    break;
                case "left-align":
                    activeObject.set("textAlign", "left");
                    break;
                case "center-align":
                    activeObject.set("textAlign", "center");
                    break;
                case "right-align":
                    activeObject.set("textAlign", "right");
                    break;
                default:
                    break;
            }
        }
        this.boldButtonDOM.blur();
        this.italicButtonDOM.blur();
        this.underlineButtonDOM.blur();
        this.leftAlignButtonDOM.blur();
        this.centerAlignButtonDOM.blur();
        this.rightAlignButtonDOM.blur();
        this.props.canvas.renderAll();
        this.updateCanvasState();
    };

    setFontSize = e => {
        let { value } = e.target;

        let fontSize = value.replace("px", "");

        let activeObject = this.props.canvas._activeObject;
        if (activeObject == null) return;

        activeObject.set("fontSize", fontSize);
        this.props.canvas.renderAll();
        this.updateCanvasState();
    };

    setLineHeight = e => {
        let { value } = e.target;
        let activeObject = this.props.canvas._activeObject;
        if (!activeObject){
            this.props.setTextLineProperty("SET_TEXT_LINE_HEIGHT",parseInt(value));
            return;
        }

        activeObject.set("lineHeight", value);
        this.props.canvas.renderAll();
        this.updateCanvasState();
    };

    setOutlineSize = e => {
        let { value } = e.target;
        this.props.setTextLineProperty("SET_TEXT_LETTER_OUTLINE",value)
        let activeObject = this.props.canvas._activeObject;
        if (activeObject == null) return;

        activeObject.set("strokeWidth", value / 1);
        this.props.canvas.renderAll();
        this.updateCanvasState();
    };

    setTextArcStyle = text_arc_style => {
        let activeObject = this.props.canvas._activeObject;
        if (activeObject == null) return;

        switch (text_arc_style) {
            case "text-style-1":
                let effect = "vertical";
                if(activeObject.get('effect') === 'vertical'){
                    effect = "STRAIGHT";
                    activeObject.set({effect:effect});
                    this.props.canvas.renderAll();
                    this.updateCanvasState();
                    return;
                }
                if(activeObject.get('effect') === 'curved') {
                    effect = "STRAIGHT";
                    activeObject.set({angle:0,effect:effect});
                    this.props.canvas.renderAll();
                    this.updateCanvasState();
                    activeObject.set({angle:0,effect:'vertical'});
                    this.props.canvas.renderAll();
                    this.updateCanvasState();
                    return;
                }
                activeObject.set({angle:0,effect:effect});
                this.props.canvas.renderAll();
                this.updateCanvasState();
                break;
            case "text-style-2":
                let effect2 = "curved";
                if(activeObject.get('effect') === 'vertical'){
                    let newTop = ((activeObject.get('height')*activeObject.get('scaleY'))/2)+activeObject.get('top');
                    let newLeft = ((activeObject.get('width')*activeObject.get('scaleX'))/2)+activeObject.get('left');
                    let point = new window.fabric.Point(newLeft,newTop);
                    activeObject.set({effect:effect2,angle:90});
                    activeObject.setPositionByOrigin(point,'center','center');

                    let x = activeObject.arcValue;
                    if(x<0){
                        let reverse = true;
                        let angle=270;
                        let y = (8*x)+500;

                        activeObject.set({radius: y,reverse});
                        activeObject.rotate(angle);
                    }

                    this.props.canvas.renderAll();
                    this.updateCanvasState();
                    return;
                }
                if ( activeObject.get('effect') === 'curved') {
                    effect2 = "STRAIGHT";
                    //activeObject.set("effect", effect2);
                    //activeObject.set("angle", 0);
                    let bounding = activeObject.getBoundingRect();
                    let point = new window.fabric.Point(bounding.left+bounding.width/2,bounding.top+bounding.height/2);
                    activeObject.set({effect:effect2,angle:0});
                    activeObject.setPositionByOrigin(point,'center','center');
                    this.props.canvas.renderAll();
                    this.updateCanvasState();
                    return;
                }
                if (activeObject.radius !== undefined) {
                    // center object by origin
                    let newTop = ((activeObject.get('height')*activeObject.get('scaleY'))/2)+activeObject.get('top');
                    let newLeft = ((activeObject.get('width')*activeObject.get('scaleX'))/2)+activeObject.get('left');
                    let point = new window.fabric.Point(newLeft,newTop);
                    activeObject.set({effect:effect2,angle:90});
                    activeObject.setPositionByOrigin(point,'center','center');

                    let x = activeObject.arcValue;
                    if(x<0){
                        let reverse = true;
                        let angle=270;
                        let y = (8*x)+500;

                        activeObject.set({radius: y,reverse});
                        activeObject.rotate(angle);
                    }

                    this.props.canvas.renderAll();
                    this.updateCanvasState();
                }
                break;
            default:
                break;
        }
    };

    setLetterSpace = e => {
        let { value } = e.target;
        this.props.setTextLineProperty("SET_TEXT_LETTER_SPACING",value)
        let activeObject = this.props.canvas._activeObject;
        if (activeObject == null) return;

        activeObject.set("spacing", value);
        this.props.canvas.renderAll();
        this.updateCanvasState();
    };

    setFontFamily = e => {
        let { value } = e.target;
        let activeObject = this.props.canvas._activeObject;
        if (activeObject == null) return;

        this.props.setTextFontFamily(value)
        let font = new FontFaceObserver(value);
        font
            .load()
            .then(() => {
                activeObject.set("fontFamily", value);
                this.props.canvas.renderAll();
                this.props.setTextConfigPanel(true , {});
            })
            .catch(e => {});

        this.updateCanvasState();
        this.props.setCurvedTextStyle({...this.props.text_style, fontFamily: value});
    };

    setRadius = e => {
        let { value } = e.target
        console.log(value)
        this.props.setTextLineProperty("SET_TEXT_LETTER_RADIUS",value)
        let activeObject = this.props.canvas._activeObject;
        if (activeObject == null) return;

        activeObject.set("radius", parseInt(value)*10);
        this.props.canvas.renderAll();
        this.updateCanvasState();
    };
    setArcRadius =e => {
        let { value } = e.target
        //console.log(value)
        this.props.setTextLineProperty("SET_ARC_TEXT_LETTER_RADIUS",value)
        let activeObject = this.props.canvas._activeObject;
        if (activeObject == null) return;
        let x = parseInt(value);
        let y;
        let reverse = false;
        let angle = 90;
        if(x<0){
            reverse = true;
            angle=270;
            y = (8*x)+500;
        }else{
            y = -(8*x)+500;
        }
        if(activeObject.get('effect') !== 'curved') {
            activeObject.set({radius: y,reverse});
            activeObject.set({arcValue: x});
            this.props.canvas.renderAll();
            this.updateCanvasState();
            return;
        }
        activeObject.set({radius: y,reverse});
        activeObject.set({arcValue: x});
        activeObject.rotate(angle);
        this.props.canvas.renderAll();
        this.updateCanvasState();
    }

    render() {
        const { text_line_height , text_letter_spacing , text_letter_outline ,text_arc_radius} = this.props;
        const { effect , fontFamily,fontSize , text , update,text_align,fontWeight,fontStyle,textDecoration} = this.props.text_toolbar_config;
        const left_align_class = `btn stl-btn ${text_align === 'left' ? 'active' : '' }`;
        const center_align_class = `btn stl-btn ${text_align === 'center' ? 'active' : '' }`;
        const right_align_class = `btn stl-btn ${text_align === 'right' ? 'active' : '' }`;
        const text_bold_class = `btn stl-btn ${fontWeight === 'bold' ? 'active' : '' }`;
        const text_italic_class = `btn stl-btn ${fontStyle === 'italic' ? 'active' : '' }`;
        const text_underline_class = `btn stl-btn ${textDecoration === 'underline' ? 'active' : '' }`;
        const classVertical = `col-md-6 spacing-val-btn ${effect === 'vertical'?'text-color-active':''}`;
        const classCurved = `col-md-6 spacing-val-btn ${effect === 'curved'?'text-color-active':''}`;
        let object = this.props.canvas.getActiveObject();
        let textEffect = false;
        if(object && (object.get('effect') === 'curved')) {
            textEffect = true;
        }
        return(
            <>
                <div className="adddiv">
                    <h2>Add Text</h2>
                </div>
                <div className="templatesmain">
                    <div className="add-new-txt">
                        <div className="row row-border-btm pd-15" style={{display: 'inline-flex'}}>
                            <input
                                type="text"
                                id="selected_text"
                                value={text}
                                onChange={this.updateText}
                            ></input>
                            <button
                                className="btn btn-danger add-text-btn"
                                onClick={() => this.addNewText()}
                                style={{padding:'0px'}}
                            >
                                { update ? 'Update Text':'Add Text'}
                            </button>
                        </div>
                    </div>
                    <div className="add-text-blk-hmenu">
                        <div className="font-select">
                            <div className="row row-border-btm pt-15">
                                <div className="col-md-8 vrtcl-dot-line">
                                    <div className="form-group">
                                        <select
                                            className="form-control slct-font-fam"
                                            value={fontFamily}
                                            onChange={this.setFontFamily}
                                        >
                                            <option>Times New Roman</option>
                                            <option>Celtic</option>
                                            <option>Martel</option>
                                            <option>FM College Team Outline</option>
                                            <option>FM College Team</option>
                                            <option>lvy League</option>
                                            <option>lvy League Outline</option>
                                            <option>Blackjack</option>
                                            <option>Ball Park</option>
                                            <option>Century Gothic</option>
                                            <option>Major Snafu</option>
                                            <option>Stencil Becker Solid</option>
                                            <option>Freshman</option>
                                            <option>InterState</option>
                                            <option>Machine BT</option>
                                            <option>Rockwell Condensed</option>
                                            <option>Rockwell</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="form-group">
                                        <select
                                            className="form-control slct-font-size"
                                            value={`${fontSize}px`}
                                            onChange={this.setFontSize}
                                        >
                                            <option val="20">20px</option>
                                            <option val="22">22px</option>
                                            <option val="24">24px</option>
                                            <option val="26">26px</option>
                                            <option val="28">28px</option>
                                            <option val="30">30px</option>
                                            <option val="32">32px</option>
                                            <option val="34">34px</option>
                                            <option val="36">36px</option>
                                            <option val="38">38px</option>
                                            <option val="40">40px</option>
                                            <option val="42">42px</option>
                                            <option val="44">44px</option>
                                            <option val="46">46px</option>
                                            <option val="48">48px</option>
                                            <option val="50">50px</option>
                                            <option val="52">52px</option>
                                            <option val="54">54px</option>
                                            <option val="56">56px</option>
                                            <option val="58">58px</option>
                                            <option val="60">60px</option>
                                            <option val="62">62px</option>
                                            <option val="64">64px</option>
                                            <option val="66">66px</option>
                                            <option val="68">68px</option>
                                            <option val="70">70px</option>
                                            <option val="72">72px</option>
                                            <option val="74">74px</option>
                                            <option val="76">76px</option>
                                            <option val="78">78px</option>
                                            <option val="80">80px</option>
                                            <option val="85">85px</option>
                                            <option val="90">90px</option>
                                            <option val="95">95px</option>
                                            <option val="100">100px</option>
                                            <option val="110">110px</option>
                                            <option val="120">120px</option>
                                            <option val="130">130px</option>
                                            <option val="140">140px</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div className="row row-border-btm pt-15 pb-15">
                                <div className="col-md-7 vrtcl-dot-line">
                                    <div className="font-stl-blk">
                                        <button
                                            id="bold"
                                            className={text_bold_class}
                                            ref={(buttonDOM) => { this.boldButtonDOM = buttonDOM; }}
                                            onClick={() => this.setTextStyle("bold")}
                                        >
                                            B
                                        </button>
                                        <button
                                            id="italic"
                                            className={text_italic_class}
                                            ref={(buttonDOM) => { this.italicButtonDOM = buttonDOM; }}
                                            onClick={() => this.setTextStyle("italic")}
                                        >
                                            <i>I</i>
                                        </button>
                                        <button
                                            id="underline"
                                            className={text_underline_class}
                                            ref={(buttonDOM) => { this.underlineButtonDOM = buttonDOM; }}
                                            onClick={() => this.setTextStyle("underline")}
                                        >
                                            <span>U</span>
                                        </button>
                                    </div>
                                </div>
                                <div className="col-md-5">
                                    <div className="font-stl-blk">
                                        <button
                                            id="left-align"
                                            className={left_align_class}
                                            ref={(buttonDOM) => { this.leftAlignButtonDOM = buttonDOM; }}
                                            onClick={() => this.setTextStyle("left-align")}
                                        ></button>
                                        <button
                                            id="center-align"
                                            className={center_align_class}
                                            ref={(buttonDOM) => { this.centerAlignButtonDOM = buttonDOM; }}
                                            onClick={() => this.setTextStyle("center-align")}
                                        ></button>
                                        <button
                                            id="right-align"
                                            className={right_align_class}
                                            ref={(buttonDOM) => { this.rightAlignButtonDOM = buttonDOM; }}
                                            onClick={() => this.setTextStyle("right-align")}
                                        ></button>
                                    </div>
                                </div>
                            </div>
                            <div className="row row-border-btm pt-15 pb-15">
                                <div className="col-md-12">
                                    <div className="line-height-blk">
                                        <div className="line-height-label">
                                            <span>Line height</span>
                                        </div>
                                        <div className="line-height-label">
                                            <div className="range-slidecontainer">
                                                <input
                                                    type="range"
                                                    min="1"
                                                    max="10"
                                                    className="range-slider range-slider-line-height"
                                                    id="line_ht_get"
                                                    style={{
                                                        background: `linear-gradient(to right, #DB2032 0%, #DB2032 ${text_line_height *
                                                        10}%, #fff ${text_line_height * 10}%, #fff 100%)`,
                                                    }}
                                                    value={text_line_height}
                                                    onChange={this.setLineHeight}
                                                ></input>
                                            </div>
                                        </div>
                                        <div className="line-height-value">
                                            <input
                                                type="number"
                                                id="line_ht_set"
                                                className="btn ln-ht-val-btn"
                                                min="1"
                                                max="10"
                                                value={text_line_height}
                                                onChange={this.setLineHeight}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-12">
                                    <div className="spacing-blk pt-10">
                                        <div className="spacing-label">
                                            <span>Spacing</span>
                                        </div>
                                        <div className="spacing-slider">
                                            <div className="range-slidecontainer">
                                                <input
                                                    type="range"
                                                    min="1"
                                                    max="100"
                                                    className="range-slider range-slider-spacing"
                                                    style={{
                                                        background: `linear-gradient(to right, #DB2032 0%, #DB2032 ${text_letter_spacing}%, #fff ${text_letter_spacing}%, #fff 100%)`,
                                                    }}
                                                    value={text_letter_spacing}
                                                    onChange={this.setLetterSpace}
                                                ></input>
                                            </div>
                                        </div>
                                        <div className="spacing-value">
                                            <input
                                                type="number"
                                                id="spacing_set"
                                                min="1"
                                                max="100"
                                                className="btn spacing-val-btn"
                                                value={text_letter_spacing}
                                                onChange={this.setLetterSpace}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <TextColorPaneConnect type='fill'/>
                            </div>
                        </div>
                    </div>
                    <div className="outline-blk pt-15">
                        <div className="choos-clr-label"><span>ADD OUTLINE</span></div>
                    </div>
                    <div className="add-text-blk-hmenu">
                        <div className="font-select">
                            <div className="row row-border-btm pt-15 pb-15">
                                <div className="col-md-12">
                                    <div className="size-blk pt-10">
                                        <div className="size-label">
                                            <span>Size</span>
                                        </div>
                                        <div className="size-slider">
                                            <div className="range-slidecontainer">
                                                <input
                                                    type="range"
                                                    min="0"
                                                    max="10"
                                                    className="range-slider"
                                                    style={{background: `linear-gradient(to right, #DB2032 0%, #DB2032 ${text_letter_outline *
                                                        10}%, #fff ${text_letter_outline * 10}%, #fff 100%)`}}
                                                    value={text_letter_outline}
                                                    onChange={this.setOutlineSize}
                                                ></input>
                                            </div>
                                        </div>
                                        <div className="size-value">
                                            <input
                                                type="number"
                                                id="size_set"
                                                className="btn size-val-btn outline-size-val-btn"
                                                min="0"
                                                max="10"
                                                value={text_letter_outline}
                                                onChange={this.setOutlineSize}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <TextColorPaneConnect type='stroke'/>
                            </div>
                        </div>
                    </div>
                    <div className="shape-blk">
                        <div className="choos-clr-label"><span>ARC or VERTICAL TEXT</span></div>
                    </div>
                    <div className="add-text-blk-hmenu">
                        <div className="font-select">
                            <div className="row pt-15">
                                <div className="col-md-12">
                                    <div className="font-stl-blk pt-10">
                                        <div className="choos-clr-label float-left">
                                            <span>Text Style</span>
                                        </div>
                                        <div className="choose-button-blk float-right" style={{display: 'inline-flex'}}>

                                            <div
                                                className={classVertical}
                                                style={{height:'32px', paddingTop:'2px',paddingBottom:'2px' , marginTop:'4px'}}
                                                onClick={() => this.setTextArcStyle("text-style-1")}
                                            >
                                                <img
                                                    src={require("./../assets/img/text_vertical.png")}
                                                    alt="style_1"
                                                    style={{width:'28px'}}
                                                    //onClick={() => this.setTextArcStyle("text-style-1")}
                                                />
                                            </div>
                                            <div
                                                className={classCurved}
                                                style={{height:'32px' , paddingTop:'2px',paddingBottom:'2px' , marginTop:'4px'}}
                                                onClick={() => this.setTextArcStyle("text-style-2")}
                                            >
                                                <img
                                                    src={require("./../assets/img/text_curve.png")}
                                                    alt="style_2"
                                                    style={{width:'28px'}}
                                                    //onClick={() => this.setTextArcStyle("text-style-2")}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/*<div className="col-md-12">
                                    <div className="arc-blk pt-10">
                                        <div className="arc-label">
                                            <span>Arc</span>
                                        </div>
                                        <div className="arc-slider">
                                            <div className="range-slidecontainer">
                                                <input
                                                    type="range"
                                                    min="10"
                                                    max="100"
                                                    step="1"
                                                    className="range-slider"
                                                    value={text_letter_radius}
                                                    style={{
                                                        background: `linear-gradient(to right, #DB2032 0%, #DB2032 ${text_letter_radius}%, #fff ${text_letter_radius}%, #fff 100%)`,
                                                    }}
                                                    onChange={this.setRadius}
                                                />
                                            </div>
                                        </div>
                                        <div className="arc-value">
                                            <input
                                                type="number"
                                                id="arc_set"
                                                min="10"
                                                max="100"
                                                step="1"
                                                className="btn size-val-btn arc-val-button"
                                                value={text_letter_radius}
                                                onChange={this.setRadius}
                                            />
                                        </div>
                                    </div>
                                </div>*/}
                                {
                                    textEffect && (
                                        <div className="col-md-12">
                                            <div className="arc-blk pt-10">
                                                <div className="arc-label">
                                                    <span>Arc</span>
                                                </div>
                                                <div className="arc-slider">
                                                    <div className="range-slider-container">
                                                        <input
                                                            type="range"
                                                            min="-50"
                                                            max="50"
                                                            step="1"
                                                            className="range-slider"
                                                            value={text_arc_radius}
                                                            style={{
                                                                background: `linear-gradient(to right, #DB2032 0%, #DB2032 ${parseInt(text_arc_radius)+50}%, #fff ${parseInt(text_arc_radius)+50}%, #fff 100%)`,
                                                            }}
                                                            onChange={this.setArcRadius}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="arc-value">
                                                    <input
                                                        type="number"
                                                        min="-50"
                                                        max="50"
                                                        step="1"
                                                        className="btn size-val-btn arc-val-button"
                                                        value={text_arc_radius}
                                                        onChange={this.setArcRadius}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    )
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }
}

const setComponentType = type => {
    return {
        type: "SET_COMPONENT_TYPE",
        component_type: type
    };
};

const setCurvedTextStyle = data => {
    return {
        type: "SET_CURVEDTEXT_STLYE",
        data: data
    };
};

const setCanvasConfig = _config => {
    return {
        type: "SET_CONFIG",
        _config
    };
};
const setTextConfigPanel = (status , text_toolbar_config)=>{
    return {
        type: 'TEXT_TOOLBAR_CONFIG',
        is_text_toolbar_active:status,
        text_toolbar_config
    }
}

const setLetterSpacingOption = option => {
    return {
        type: "SET_LETTER_SPACING_OPTION",
        option: option
    };
};

const setSelectedText = text => {
    return {
        type: "SET_SELECTED_TEXT",
        text: text
    };
};

const setTextColorOption = option => {
    return {
        type: "SET_TEXT_COLOR_OPTION",
        option
    };
};
const setTextPanelText = text => {
    return {
        type: "SET_TEXT_PANEL_TEXT",
        text
    };
};
const setTextFontFamily = fontFamily => {
    return {
        type: "SET_TEXT_PANEL_FONT_FAMILY",
        fontFamily
    };
};
const setTextLineProperty = (type,value) => {
    return {
        type,
        value
    };
};


const mapDispatchToPropsForText = dispatch => {
    return bindActionCreators(
        {
            setComponentType,
            setCurvedTextStyle,
            setCanvasConfig,
            setLetterSpacingOption,
            setSelectedText,
            setTextColorOption,
            setTextPanelText,
            setTextConfigPanel,
            setTextFontFamily,
            setTextLineProperty
        },
        dispatch
    );
};

const mapStateToProps = state => {
    return {
        _config: state._config,
        canvas: state.canvas,
        canvas_grid: state.canvas_grid,
        templates: state.templates,
        logo_url: state.logo_url,
        text_style: state.text_style,
        text_line_height:state.text_line_height,
        text_arc_radius:state.text_arc_radius,
        text_letter_spacing:state.text_letter_spacing,
        text_letter_outline:state.text_letter_outline,
        text_letter_radius:state.text_letter_radius,
        text_toolbar_config:state.text_toolbar_config,
        is_text_toolbar_active:state.is_text_toolbar_active,
    };
};

const TextToolConnect = connect(
    mapStateToProps,
    mapDispatchToPropsForText
)(TextTool);


class TextToolBar extends React.Component {
    closeNav = () => {
        document.getElementById("mySidenav11") &&(document.getElementById("mySidenav11").style.width = "0");
    };

    render() {
        return (
            <>
                <div
                    id="text"
                    className="h100 second-menu fordeskview"
                    style={{ display: "none" }}
                >
                    <TextToolConnect />
                </div>
                <div
                    className="text-center h100 pad0 mtopneg sidenav4 formobview wo"
                    id="mySidenav11"
                >
                    <a
                        style={{ color: "#fff" }}
                        href="#"
                        className="closebtn"
                        onClick={() => this.closeNav()}
                    >
                        &times;
                    </a>
                    <TextToolConnect />
                </div>
            </>
        );
    }
}

export default TextToolBar;
